export const MNEMONIC_FABRIC_PROPERTIES = [
    'id',
    'imageFileId',
    'name',
    'objectType',
    'tooltip',
    'deviceId',
    'variableId',
    'selectOption',
    'src',
    'chart',
    'gauge',
    'text',
    'isStatusColor',
] as const;

export const MNEMONIC_CANVAS_META_KEYS = ['canvasZoom', 'viewPort', 'width', 'height'] as const;

export const LEGACY_CHART_TYPES = new Set(['chart-js-fabric', 'chartjs']);
